import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from "date-fns";

export function formatTimeUntilStart(startAt: string): string {
  const now = new Date();
  const start = new Date(startAt);

  const days = differenceInDays(start, now);
  if (days > 0) {
    return `in ${days}d`;
  }

  const hours = differenceInHours(start, now);
  if (hours > 0) {
    return `in ${hours}h`;
  }

  const minutes = differenceInMinutes(start, now);
  if (minutes > 0) {
    return `in ${minutes}m`;
  }

  return "";
}
